import {
	IonButton,
	IonCard,
	IonCardContent,
	IonIcon,
	useIonToast,
} from "@ionic/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import WithNavigation from "../../hoc/with-navigation";
import { useAbout } from "../../store/about";
import { refresh } from "ionicons/icons";

import "./styles.css";


const About: React.FC = () => {
	const { t } = useTranslation();
	const aboutStore = useAbout();

	const [present, dismiss] = useIonToast();

	useEffect(() => {
		aboutStore.checkLicense();
	}, []);

	useEffect(() => {
		if (aboutStore.refreshLicenseReqInfo?.success) {
			present({
				message: t("about.license.refreshSuccess"),
				duration: 3000,
				onDidDismiss: aboutStore.resetRefreshLicense,
			});
		}
		if (aboutStore.refreshLicenseReqInfo?.error) {
			present({
				message: aboutStore.refreshLicenseReqInfo.error,
				duration: 3000,
				onDidDismiss: aboutStore.resetRefreshLicense,
			});
		}
	}, [aboutStore.refreshLicenseReqInfo]);

	return (
		<WithNavigation preventGoBack={false} showLogo={true}>
			<IonCard>
				{aboutStore.license && (
					<IonCardContent>
						<div style={{ display: "flex", borderBottom: "1px solid #e0e0e0", paddingBottom: "10px"}}>
							<p style={{ paddingTop: 13, fontWeight: "bold"}}>
								{t("about.validThru")} {aboutStore.license}
							</p>
							<IonButton
								fill="clear"
								onClick={aboutStore.refreshLicense}
								disabled={aboutStore.refreshLicenseReqInfo?.loading}
							>
								<IonIcon slot="icon-only" icon={refresh}></IonIcon>
							</IonButton>
						</div>
					</IonCardContent>
				)}
				<IonCardContent>
					<div style={{ textAlign: "center" }}>

						<p style={{ paddingBottom: 10 }}>{t("about.descriptionTxt")}</p>
						<p style={{ paddingBottom: 10 }}>{t("about.creditsTxt")}</p>
		
						<p style={{ fontWeight: "bold" }}>www.acruxsoft.net</p>
						<p style={{ fontWeight: "bold" }}>info@acruxsoft.com.uy</p>
						<p style={{ paddingBottom: 10, fontWeight: "bold" }}>Copyright AcruxSoft SRL</p>

						<div className="logo-container">
							<img src="/assets/powered-by.png" alt="Powered by Acruxsoft" />
						</div>
					</div>
				</IonCardContent>
			</IonCard>
		</WithNavigation>
	);
};

export default About;
